import React from 'react';
import OverdueDataStatistics from './OverdueDataStatistics';

const BadDebtDataStatistics: React.FC = () => (
  <OverdueDataStatistics metric="bad_debt_count" title="坏账数据统计" />
);

export default BadDebtDataStatistics;
